import { useEffect, useState } from "react";
import { ArrowsClockwise, X } from "@phosphor-icons/react";
import { registerServiceWorker, activateWaitingWorker } from "../lib/registerSW";

// Banner that appears when a new service-worker version is installed and waiting.
export default function UpdateBanner() {
    const [waitingReg, setWaitingReg] = useState(null);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        registerServiceWorker({
            onUpdate: (reg) => setWaitingReg(reg),
        });
    }, []);

    if (!waitingReg || dismissed) return null;

    return (
        <div
            className="fixed left-1/2 -translate-x-1/2 z-[60] bottom-16 sm:bottom-14 w-[calc(100vw-1rem)] sm:w-auto sm:max-w-md"
            data-testid="pwa-update-banner"
            role="status"
            aria-live="polite"
        >
            <div className="flex items-center gap-3 bg-civic-700 text-white shadow-lg rounded-md px-4 py-3 border border-civic-500/40">
                <ArrowsClockwise size={20} weight="bold" className="text-emerald-300 shrink-0" />
                <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold">New version available</div>
                    <div className="text-[11px] text-civic-100/90 leading-snug">
                        Reload to get the latest E-VoteVerify build.
                    </div>
                </div>
                <button
                    type="button"
                    onClick={() => activateWaitingWorker(waitingReg)}
                    className="shrink-0 bg-emerald-500 hover:bg-emerald-400 text-civic-900 font-semibold text-xs px-3 py-1.5 rounded transition-colors"
                    data-testid="pwa-update-reload"
                >
                    Reload
                </button>
                <button
                    type="button"
                    onClick={() => setDismissed(true)}
                    aria-label="Dismiss"
                    className="shrink-0 p-1 rounded text-civic-100/80 hover:text-white hover:bg-white/10 transition-colors"
                    data-testid="pwa-update-dismiss"
                >
                    <X size={14} weight="bold" />
                </button>
            </div>
        </div>
    );
}
